import React, { useState, useEffect } from "react";
import { Navbar, Nav, Button, Badge, Dropdown } from 'react-bootstrap';
import { useSelector } from "react-redux";
import { Link, useNavigate, useLocation } from 'react-router-dom';
import Auth from './utils/auth';
import Cart from "../components/pages/Cart";
import Offcanvas from 'react-bootstrap/Offcanvas';
import { FaShoppingCart, FaBars } from "react-icons/fa";

function NavTabs({ currentPage, handlePageChange }) {
  const [showCart, setShowCart] = useState(false);
  const cartItems = useSelector((state) => state.cart);
  const [notificationCount, setNotificationCount] = useState(0);
  const navigate = useNavigate();
  const [formState, setFormState] = useState({});
  const [isTransparent, setIsTransparent] = useState(true);
  const [hovering, setHovering] = useState(false);
    const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsTransparent(window.scrollY <= 100);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    if (Auth.loggedIn()) {
      const userProfile = Auth.getProfile();
      fetch(`https://second-team-productions.onrender.com/notifications/${userProfile.userId}`)
        .then(res => res.json())
        .then(data => setNotificationCount(data.unreadCount))
        .catch(err => console.error("Failed to fetch notifications:", err));

      fetch(`https://second-team-productions.onrender.com/crew/${userProfile.userId}`)
        .then(res => res.json())
        .then(data => setFormState(data))
        .catch(err => console.error("Error fetching profile image:", err));
    }
  }, []);

  const goToProfile = () => {
    const userProfile = Auth.getProfile();
    navigate(`/crewProfile/${userProfile.userId}`);
  };

  const navItems = [
    { label: 'Home', to: '/', page: 'Home' },
    { label: 'TFDirect', to: '/TFDirect', page: 'Directory' },
    { label: 'Studio Services', to: '/Studios', page: 'Studios' },
    { label: 'About', to: '/About', page: 'About' },
  ];

  return (
    <>
      <Navbar
       className="main-navbar"
        variant="dark"
        fixed="top"
        style={{
          transition: "background 0.3s ease",
          backgroundColor: isTransparent ? "transparent" : "rgba(0,0,0)",
          boxShadow: isTransparent ? "none" : "0 2px 4px rgba(0,0,0,0.2)",
          padding: '1.1rem 1rem',
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <Navbar.Brand as={Link} to="/" onClick={() => handlePageChange('Home')} className="brand-link">
          <h2 style={{ margin: 0 }}>2nd Team Productions</h2>
        </Navbar.Brand>

        {/* DESKTOP nav links — hidden below md */}
         <Nav className="d-none d-md-flex align-items-center" style={{ gap: '10px', marginLeft: '20px' }}>
          {navItems.map((item) => (
            <Nav.Link
              key={item.page}
              as={Link}
              to={item.to}
              onClick={() => handlePageChange(item.page)}
              className={location.pathname === item.to ? 'nav-link active' : 'nav-link'}
              style={{ display: 'flex', alignItems: 'center', color: 'silver' }}
            >
              {item.label}
            </Nav.Link>
          ))}
            <Nav.Link
          onClick={() => setShowCart(true)}
          style={{ display: 'flex', alignItems: 'center', color: 'silver', position: 'relative' }}
            >
              <FaShoppingCart size={20} />
              {cartItems.length > 0 && (
                <Badge bg="danger" pill style={{ position: "absolute", top: 0, right: -6 }}>
                  {cartItems.length}
                </Badge>
              )}
            </Nav.Link>
        </Nav>

        <div style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center', gap: '12px' }}>

          {/* Profile image + hover logout menu — desktop only */}
          {Auth.loggedIn() && formState.profileI && formState.profileI.length > 0 && (
            <div
              className="d-none d-md-block"
              style={{ position: 'relative' }}
              onMouseEnter={() => setHovering(true)}
              onMouseLeave={() => setHovering(false)}
            >
              <img
                src={formState.profileI[0]}
                alt="Profile"
                onClick={goToProfile}
                style={{
                  width: 40,
                  height: 40,
                  borderRadius: '50%',
                  objectFit: 'cover',
                  cursor: 'pointer',
                }}
              />
           {hovering && (
  <div className="dark-dropdown-menu"
    style={{
      position: 'absolute',
      top: '40px',
      right: 0,
      backgroundColor: '#1a1a1a',
      border: '1px solid rgba(255,255,255,0.1)',
      borderRadius: '4px',
      paddingTop: '8px',
      paddingBottom: '6px',
      minWidth: '140px',
      zIndex: 2000,
    }}
  >
    <div
      onClick={() => Auth.logout()}
      className="dropdown-item"
      style={{ padding: '8px 16px', color: 'silver', cursor: 'pointer' }}
    >
      Sign out
    </div>
  </div>
)}
            </div>
          )}

          {/* Profile image — mobile only, no hover menu, plain click-to-navigate */}
          {Auth.loggedIn() && formState.profileI && formState.profileI.length > 0 && (
            <img
              src={formState.profileI[0]}
              alt="Profile"
              onClick={goToProfile}
              className="d-md-none"
              style={{
                width: 40,
                height: 40,
                borderRadius: '50%',
                objectFit: 'cover',
                cursor: 'pointer',
              }}
            />
          )}

          {/* MOBILE dropdown toggle — hidden at md and up */}
          <Dropdown align="end" className="d-md-none">
            <Dropdown.Toggle
              variant="dark"
              style={{ background: 'transparent', border: 'none', boxShadow: 'none' }}
            >
              <FaBars color="silver" size={20} />
            </Dropdown.Toggle>
            <Dropdown.Menu 
            className="dark-dropdown-menu"
            style={{ backgroundColor: '#1a1a1a', border: '1px solid rgba(255,255,255,0.1)' }}>
              {navItems.map((item) => (
                <Dropdown.Item
                  key={item.page}
                  as={Link}
                  to={item.to}
                  onClick={() => handlePageChange(item.page)}
                  style={{ color: 'silver' }}
                >
                  {item.label}
                </Dropdown.Item>
              ))}
              <Dropdown.Item onClick={() => setShowCart(true)} style={{ color: 'silver' }}>
                <FaShoppingCart size={20} />
                {cartItems.length > 0 && (
                  <Badge bg="danger" pill style={{ position: "absolute", top: 0, right: -6 }}>
                    {cartItems.length}
                  </Badge>
                )}
              </Dropdown.Item>

              {Auth.loggedIn() ? (
                <>
                  <Dropdown.Divider />
                  <Dropdown.Item onClick={() => Auth.logout()} style={{ color: 'silver' }}>
                    Sign out
                  </Dropdown.Item>
                </>
              ) : (
                <>
                  <Dropdown.Divider />
                  <Dropdown.Item
                    as={Link}
                    to="/Login"
                    onClick={() => handlePageChange('Login')}
                    style={{ color: 'silver' }}
                  >
                    Login
                  </Dropdown.Item>
                </>
              )}
            </Dropdown.Menu>
          </Dropdown>

          {/* DESKTOP-only login link when logged out */}
          {!Auth.loggedIn() && (
            <Nav.Link
              as={Link}
              to="/Login"
              onClick={() => handlePageChange('Login')}
              className="d-none d-md-inline-flex"
              style={{ color: 'silver' }}
            >
              Login
            </Nav.Link>
          )}
        </div>
      </Navbar>

      <Offcanvas show={showCart} onHide={() => setShowCart(false)} placement="end" className="cart-background">
        <Offcanvas.Header className="title-font justify-content-center">
          <Offcanvas.Title>
            <h5 style={{ marginTop: "4%", marginBottom: "1%" }}>shopping cart</h5>
          </Offcanvas.Title>
          <Button
            type="button"
            onClick={() => setShowCart(false)}
            style={{
              marginLeft: "auto",
              background: "transparent",
              border: "none",
              fontSize: "1.5rem",
              color: "silver",
              cursor: "pointer",
            }}
          >
            ✕
          </Button>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Cart />
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
}

export default NavTabs;